





































//import { cloneDeep } from "lodash";
import Vue from "vue";
//import { SET_OPTIONS } from "@/store/Editor/mutations";
//import { updateCanvas } from "@/utils/handleCanvas";
import handleCanvas from "@/mixin/handleCanvas";
export default Vue.extend({
  mixins: [handleCanvas],
  props: {
    label: String,
    type: String,
    items: [],
  },
  data() {
    return {
      //labelList: [
      //  { fontFamily: "폰트 종류" },
      //  { fontSize: "폰트 사이즈" },
      //  { fontColor: "폰트 색상" },
      //  { fontWeight: "폰트 두께" },
      //  { textBorder: "폰트 테두리" },
      //],
    };
  },
});
